import { SHARED_MODULES_COLUMN_ID } from "../constants";
import SharedModulesTableDescriptionCell from "./DescriptionCell";
import SharedModulesTableRowActionsCell from "./RowActionsCell";
import SharedModulesTableNameCell from "./NameCell";
import SharedModulesTableVersionCell from "./VersionCell";
import SharedModulesTableSharedFromCell from "./SharedFromCell";
import SharedModulesTableTypeCell from "./TypeCell";
import SharedModulesTableSharedToCell from "./SharedToCell";

export const SHARED_MODULES_TABLE_CELLS = {
  [SHARED_MODULES_COLUMN_ID.NAME]: SharedModulesTableNameCell,
  [SHARED_MODULES_COLUMN_ID.DESCRIPTION]: SharedModulesTableDescriptionCell,
  [SHARED_MODULES_COLUMN_ID.VERSION]: SharedModulesTableVersionCell,
  [SHARED_MODULES_COLUMN_ID.TYPE]: SharedModulesTableTypeCell,
  [SHARED_MODULES_COLUMN_ID.SHARED_FROM]: SharedModulesTableSharedFromCell,
  [SHARED_MODULES_COLUMN_ID.SHARED_TO]: SharedModulesTableSharedToCell,
  [SHARED_MODULES_COLUMN_ID.DROPDOWN]: SharedModulesTableRowActionsCell,
};
